import React, { useEffect, useState } from "react";
import homeVideo from "../../assets/home.mp4";
import homePoster from "../../assets/home.jpeg";

const taglines = [
  "Connecting East Africa",
  "Delivering Excellence",
  "Your Logistics Partner",
];

const Hero = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(
      () => setIndex((i) => (i + 1) % taglines.length),
      3500
    );
    return () => clearInterval(id);
  }, []);

  const scrollToServices = () => {
    document
      .getElementById("core-services")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative flex min-h-[80vh] items-center justify-center overflow-hidden bg-inverse-surface">
      {/* Video background */}
      <div className="absolute inset-0 z-0">
        <video
          src={homeVideo}
          poster={homePoster}
          className="h-full w-full object-cover opacity-40 mix-blend-overlay"
          autoPlay
          loop
          muted
          playsInline
        />
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center gap-stack-lg px-margin-mobile text-center md:px-gutter">
        <h1 className="mb-4 font-display-lg text-4xl uppercase text-white drop-shadow-lg sm:text-5xl md:text-display-lg">
          <span key={index} className="inline-block animate-[fadeIn_0.6s_ease]">
            {taglines[index]}
          </span>
        </h1>
        <p className="mb-8 max-w-2xl font-body-lg text-body-lg text-secondary-fixed-dim">
          Cargo Power Logistics — forward momentum, absolute reliability, and
          high-tech precision in global shipping across East Africa and beyond.
        </p>
        <button
          type="button"
          onClick={scrollToServices}
          className="btn-primary px-8 py-4"
        >
          Get Started
        </button>
      </div>

      {/* Tech accent line */}
      <div className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r from-transparent via-primary-container to-transparent opacity-70" />
    </section>
  );
};

export default Hero;
